import create from '../creator'
import axios from '../../axios-setup'

const initialState = () => ({
	token: window.localStorage.getItem('token'),
	id: null
})
const state = initialState()

const actions = {
	async login({ commit }) {
		const resp = await axios.post(`auth/login`)
		commit('setToken', resp.data)
	},

	async getUser({ commit }, venueId = null) {
		const params = venueId ? { venueId } : {}
		const resp = await axios.get(`account/me`, { params })
		commit('setUser', resp.data)
	},

	logout({ commit }) {
		commit('logout')
		commit('payment/resetState', null, { root: true })
		commit('cart/resetState', null, { root: true })
	}
}

const mutations = {
	setToken(state, { access_token }) {
		state.token = access_token
		window.localStorage.setItem('token', access_token)
	},

	updateToken(state) {
		state.token = window.localStorage.getItem('token')
	},

	removeToken(state) {
		state.token = null
		window.localStorage.removeItem('token')
	},

	logout(state) {
		state.token = null
		state.id = null
		window.localStorage.removeItem('token')
	},

	setUser(state, data) {
		state.id = data.id
	}
}

const getters = {
	token(state) {
		return state.token
	}
}

export default create(
	{
		namespaced: true,
		state,
		actions,
		mutations,
		getters
	},
	initialState()
)
